import React from "react";
import { useLocalStore, useObserver } from "mobx-react";
import { Grid } from "@material-ui/core";
import EditPageLayout from "@components/layouts/EditPageLayout";
import { ContactPersonForm } from "@containers/ContactPersonEditor/ContactPersonForm";
import { Actions, PrimaryButton, RegularButton, Spinner } from "@components";
import locale from "@bonliva-crm/locale";
import { CustomerContactPersonFormStore } from "./CustomerContactPersonFormStore";
import CustomerCard from "../CustomerCard/CustomerCard";
import CustomerContactPersons from "../CustomerContactPersons/CustomerContactPersons";
import { useNavigation } from "@navigation";

type Props = {
  customerId: string;
  contactPersonId: string | null;
  initialData?: InitialContactPersonData;
};

export interface InitialContactPersonData {
  BooksProfessions: string[];
  Roles: string[];
  CustomerGroups: string[];
}

export function CustomerContactPersonForm(props: Props) {
  const navigation = useNavigation();

  const localStore = useLocalStore(
    () =>
      new CustomerContactPersonFormStore(
        props.customerId,
        props.contactPersonId,
        props.initialData,
        navigation
      )
  );

  return useObserver(() => {
    if (localStore.loading) {
      return <Spinner fullHeight />;
    }
    return (
      <EditPageLayout fitted>
        <Grid container spacing={2} style={{ padding: 16 }}>
          <Grid item xs={12}>
            <CustomerCard
              data={localStore.customerData as any}
              onParentClick={() => null}
            />
          </Grid>

          <Grid item xs={6}>
            <ContactPersonForm store={localStore.formStore} />

            <Actions style={{ marginTop: 16 }}>
              <RegularButton
                disabled={!localStore.dirty}
                style={{ marginLeft: "auto" }}
                onClick={localStore.reset}
              >
                {locale.Reset}
              </RegularButton>

              <PrimaryButton
                loading={localStore.formStore.isSubmitting}
                disabled={!localStore.canSubmit || localStore.formStore.isSubmitting}
                onClick={localStore.submit}
              >
                {locale.Save}
              </PrimaryButton>
            </Actions>
          </Grid>

          <Grid item xs={6}>
            <CustomerContactPersons
              loading={localStore.isLoadingContactPersons}
              data={localStore.contactPersons.slice().map((item) => ({ item }))}
              onClick={(row) => localStore.assignContactPerson(row._id, row.Name)}
              withCheckboxes={false}
            />
          </Grid>
        </Grid>
      </EditPageLayout>
    );
  });
}
